import { ScMenu } from './sc-menu.model';

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';

import { AuthService } from 'src/app/core/auth/auth.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { VMessageModule } from 'src/app/shared/components/vmessage/vmessage.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CardModule } from 'primeng/card';
import { TreeSelectModule } from 'primeng/treeselect';
import { ToolbarModule } from 'primeng/toolbar';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';

import { ScMenuTreeComponent } from './sc-menu/sc-menu-tree.component';
import { ScMenuService } from './sc-menu.service';
import { ScMenuDropdownComponent } from './sc-menu-dropdown/sc-menu-dropdown.component';
import { SfDropDownModule } from 'src/app/shared/components/dropdown/dropdown.module';

import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { ScClaimModule } from '../sc-claim/sc-claim.module';



@NgModule({
    declarations: [ScMenuTreeComponent, ScMenuDropdownComponent],
    exports: [ScMenuTreeComponent, ScMenuDropdownComponent ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        VMessageModule,
        RouterModule,
        NotificationsModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        TranslateModule,
        MessageModule,
        MessagesModule,
        CardModule,
        ConfirmDialogModule,
        TooltipModule,
        TreeSelectModule,
        ToolbarModule,
        DropdownModule,
        SfDropDownModule,
        CheckboxModule,
        ProgressBarModule,
        ScClaimModule,
        LoaderModule

    ],
    providers: [NotificationsService, AuthService, AuthorizationGuard, ScMenuService]
})
export class ScMenuModule { }
